var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ueber-uns'),_c('div',{staticClass:"mx-2"},[_c('dienstleistungen'),_c('sanierung'),_c('spritzverfugung'),_c('bauen'),_c('mauerwerk'),_c('kernbohrungen'),_c('holzrestaurierung'),_c('aktion')],1),_c('kontaktformular')],1)}
var staticRenderFns = []

export { render, staticRenderFns }